module.exports = __webpack_public_path__ + "img/link-banner-jp.18ac6038.png";